import { RESET_DATASET } from 'store';

import { SET_TEST_SELECTION } from './types';
import { RESET_RANDOMIZATION_HYPOTHESIS_TESTING } from '../types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_TEST_SELECTION:
      return action.testSelection;
    case RESET_DATASET:
    case RESET_RANDOMIZATION_HYPOTHESIS_TESTING:
      return null;
    default:
      return state;
  }
};
